export default __webpack_public_path__ + "0980bb33f4c158137771eb8cad2dfa58.svg";